import { render, staticRenderFns } from "./VisitDetailsHistory.vue?vue&type=template&id=0753a0e6"
import script from "./VisitDetailsHistory.vue?vue&type=script&lang=js"
export * from "./VisitDetailsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0753a0e6')) {
      api.createRecord('0753a0e6', component.options)
    } else {
      api.reload('0753a0e6', component.options)
    }
    module.hot.accept("./VisitDetailsHistory.vue?vue&type=template&id=0753a0e6", function () {
      api.rerender('0753a0e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/VisitDetailsHistory.vue"
export default component.exports